import { ERouteLinks } from 'models/route';

export interface IMenuItem {
  label: string;
  url: string;
  items?: string[];
  disabled?: boolean;
}

export const MenuItems: IMenuItem[] = [
  {
    label: 'Dashboard',
    url: ERouteLinks.Dashboard,
  },
  {
    label: 'Apply',
    url: ERouteLinks.ApplyOnline,
  },
  {
    label: 'My Applications',
    url: ERouteLinks.MyApplications,
  },
  {
    label: 'Licences',
    url: ERouteLinks.NotFound,
    disabled: true,
  },
  {
    label: 'Firearms',
    url: ERouteLinks.NotFound,
    disabled: true,
  },
];
